import { ProductModel } from '../models/product.model';

export const products: ProductModel[] = [
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 85,
    newPrice: 59,
    specification: ['vegetarian', 'spicy'],
    category: 1,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/hawaiian.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 0,
    newPrice: 40,
    specification: ['vegetarian', 'spicy'],
    category: 1,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/hawaiian.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 0,
    newPrice: 40,
    specification: ['vegetarian', 'spicy'],
    category: 2,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 85,
    newPrice: 59,
    specification: ['vegetarian', 'spicy'],
    category: 1,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 0,
    newPrice: 40,
    specification: ['vegetarian', 'spicy'],
    category: 4,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 85,
    newPrice: 59,
    specification: ['vegetarian', 'spicy'],
    category: 5,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 85,
    newPrice: 59,
    specification: ['vegetarian', 'spicy'],
    category: 6,
    isNew: false
  },
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 85,
    newPrice: 59,
    specification: ['vegetarian', 'spicy'],
    category: 1,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/hawaiian.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 85,
    newPrice: 59,
    specification: ['vegetarian', 'spicy'],
    category: 5,
    isNew: false
  },
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 85,
    newPrice: 59,
    specification: ['vegetarian', 'spicy'],
    category: 2,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 85,
    newPrice: 59,
    specification: ['vegetarian', 'spicy'],
    category: 3,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 85,
    newPrice: 59,
    specification: ['vegetarian', 'spicy'],
    category: 2,
    isNew: false
  },
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 0,
    newPrice: 40,
    specification: ['vegetarian', 'spicy'],
    category: 3,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/hawaiian.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 0,
    newPrice: 40,
    specification: ['vegetarian', 'spicy'],
    category: 4,
    isNew: true
  },
  {
    id: 1,
    image: 'assets/images/garlic-prawn.png',
    title: 'פיצה משפחתית טבעונית L',
    description1: 'פיצה משפחתית טבעונית',
    description2: '+ תוספת + מאפה זיוה',
    oldPrice: 85,
    newPrice: 59,
    specification: ['vegetarian', 'spicy'],
    category: 4,
    isNew: true
  }
];
